"use client";

import * as S from "./index.styles";

const Loading = () => {
  return (
    <S.LoadingContainer>
      <S.LoadingCircle />
    </S.LoadingContainer>
  );
};

export default Loading;
